module.exports = __webpack_public_path__ + "img/adminhomepage.f5c3490d.png";